<template>
    <nav id="sidebar" aria-label="Main Navigation">
        <!-- Side Header -->
        <div class="content-header">
            <!-- Logo -->
            <a class="fw-semibold text-white">
                <span class="smini-visible">
                    <i class="fa fa-circle-notch text-white"></i>
                    <!-- <img class="img-icon" src="@/images/svg/icon/icon.white.svg" alt="logo" /> -->
                </span>
                <span class="smini-hide fs-5 tracking-wider pushback text-white">
                    {{ app_name }}
                    <!-- <img class="img-banner" src="@/images/svg/banner/banner.white.svg" alt="banner" /> -->
                </span>
            </a>
            <!-- END Logo -->

            <!-- Extra -->
            <div>
                <!-- Dark Mode -->
                <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
                <button type="button" class="btn btn-sm btn-alt-secondary" data-toggle="layout" data-action="dark_mode_toggle">
                    <i class="far fa-moon"></i>
                </button>
                <!-- END Dark Mode -->

                <!-- Close Sidebar, Visible only on mobile screens -->
                <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
                <a class="d-lg-none btn btn-sm btn-alt-secondary ms-1" data-toggle="layout" data-action="sidebar_close" href="javascript:void(0)">
                    <i class="fa fa-fw fa-times"></i>
                </a>
                <!-- END Close Sidebar -->
            </div>
            <!-- END Extra -->
        </div>
        <!-- END Side Header -->

        <!-- Sidebar Scrolling -->
        <div class="js-sidebar-scroll">
            <!-- Side Navigation -->
            <div class="content-side">
                <MenuList :menu="menu" />
            </div>
            <!-- END Side Navigation -->
        </div>
        <!-- END Sidebar Scrolling -->
    </nav>
</template>

<script lang="ts">
import { hasRole, Role } from '@/models/Admin'
import MenuList from '@/vue/components/Menu.vue'
import { MenuItem } from '@/vue/utils/Menu'
import { Component, toNative, Vue } from 'vue-facing-decorator'

@Component({
    components: {
        MenuList,
    },
})
class SidebarLeft extends Vue {
    get app_name() {
        return import.meta.env.VITE_APP_NAME
    }

    menu: MenuItem[] = [
        {
            label: 'Dashboard',
            name: 'dashboard.page',
            icon: 'fas fa-gauge',

        },
        {
            label: 'Admins',
            name: 'admin.page.group',
            icon: 'fas fa-user-ninja',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER],
            submenu: [
                {
                    label: 'Admins',
                    name: 'admin.page.group',

                },
                {
                    label: 'Create Admin',
                    name: 'admin.page.create',

                },

            ],
        },
        {
            label: 'Financiers',
            name: 'financier.page.group',
            icon: 'fas fa-user-ninja',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER],
            submenu: [
                {
                    label: 'Financiers',
                    name: 'financier.page.group',

                },
                {
                    label: 'Create Financier',
                    name: 'financier.page.create',
                },
            ],
        },
        {
            label: 'Data Import & Export',
            name: 'data.page',
            icon: 'fas fa-database',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER],
        },
        {
            label: 'Inventory',
            name: '',
            heading: true,
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER],
        },
        {
            label: 'Inventory Management',
            name: 'warehouse.page.group',
            icon: 'fas fa-home',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.WAREHOUSE_MANAGER, Role.STATION_MANAGER, Role.STATION_OFFICER],
            submenu: [
                {
                    label: 'Warehouses',
                    name: 'warehouse.page.group',
                    role: [Role.SUPER_ADMIN]

                },
                {
                    label: 'Create Warehouse',
                    name: 'warehouse.page.create',
                    role: [Role.SUPER_ADMIN]

                },
                {
                    label: 'Allocation History',
                    name: 'batch.page.group',
                },
                // {
                //     label: 'Stocks',
                //     name: 'stock.page.group',
                // },
                // {
                //     label: 'Create Stocks',
                //     name: 'stock.page.create',
                //     role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER,Role.WAREHOUSE_MANAGER]
                // },
                // {
                //     label: 'Dispatch Inventories',
                //     name: 'assignment.page.create',
                // },
            ],
        },

        /* {
             label: 'Inventories',
             name: 'batch.page.group',
             icon: 'fas fa-boxes',
             role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER],

             submenu: [
                 {
                     label: 'Inventories',
                     name: 'batch.page.group',
                 },
                 {
                     label: 'Dispatch Inventories',
                     name: 'assignment.page.create',
                 },

             ],
         },
         */

        {
            label: 'Stations',
            name: 'station.page.group',
            icon: 'fas fa-charging-station',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.STATION_MANAGER],
            submenu: [
                {
                    label: 'Stations',
                    name: 'station.page.group',
                    role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER]
                },
                {
                    label: 'Create Station',
                    name: 'station.page.create',
                    role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER]
                },
                {
                    label: 'Pricing',
                    name: 'price.page.group',
                    role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.STATION_MANAGER]
                },
                {
                    label: 'Discount',
                    name: 'discount.page.group',
                    role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.STATION_MANAGER]
                },
            ],
        },
        // {
        //     label: 'Clusters',
        //     name: 'cluster.page.group',
        //     icon: 'fas fa-charging-station',
        //     role: [Role.SUPER_ADMIN, Role.CLUSTER_MANAGER],
        //     submenu: [
        //         {
        //             label: 'Clusters',
        //             name: 'cluster.page.group',
        //         },
        //         {
        //             label: 'Create Cluster',
        //             name: 'cluster.page.create',
        //         },
        //     ],
        // },

        {
            label: 'Riders',
            name: 'rider.page.group',
            icon: 'fas fa-person-biking',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.CLUSTER_MANAGER, Role.STATION_MANAGER, Role.STATION_OFFICER, Role.FINANCIER],
            submenu: [
                {
                    label: 'Riders',
                    name: 'rider.page.group',
                },
                {
                    label: 'Create Rider',
                    name: 'rider.page.create',
                    role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.CLUSTER_MANAGER, Role.STATION_MANAGER]

                },
            ],
        },

        // {
        //     label: 'Stocks',
        //     name: 'stock.page.group',
        //     icon: 'fas fa-gears',
        //     role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER],
        //     submenu: [
        //         {
        //             label: 'Stock',
        //             name: 'stock.page.group',
        //         },
        //         {
        //             label: 'Create Stocks',
        //             name: 'stock.page.create',
        //         },
        //     ],
        // },
        // {
        //     label: 'Batteries',
        //     name: 'battery.page.group',
        //     icon: 'fas fa-battery-full',
        //     role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.CLUSTER_MANAGER, Role.STATION_MANAGER],
        //     submenu: [
        //         {
        //             label: 'Battery',
        //             name: 'battery.page.group',
        //         },
        //         {
        //             label: 'Create  Battery',
        //             name: 'battery.page.create',
        //         },
        //     ],
        // },

        // {
        //     label: 'Stocks',
        //     name: 'stock.page.group',
        //     icon: 'fas fa-gears',
        //     role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER],
        //     submenu: [
        //         {
        //             label: 'Stock',
        //             name: 'stock.page.group',
        //         },
        //         {
        //             label: 'Create Stocks',
        //             name: 'stock.page.create',
        //         },
        //     ],
        // },
        {
            label: 'Batteries',
            name: 'battery.page.group',
            icon: 'fas fa-battery-full',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.CLUSTER_MANAGER, Role.STATION_MANAGER],
            submenu: [
                {
                    label: 'Battery',
                    name: 'battery.page.group',
                },
                // {
                //     label: 'Create  Battery',
                //     name: 'battery.page.create',
                // },
            ],
        },


        {
            label: 'Engines',
            name: 'engine.page.group',
            icon: 'fas fa-gears',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.CLUSTER_MANAGER, Role.STATION_MANAGER],
            submenu: [
                {
                    label: 'Engine',
                    name: 'engine.page.group',
                },
                // {
                //     label: 'Create Engine',
                //     name: 'engine.page.create',
                // },
            ],
        },
        {
            label: 'Assets',
            name: 'engine.page.group',
            icon: 'fas fa-gears',
            role: [Role.FINANCIER],
            submenu: [
                {
                    label: 'Assets',
                    name: 'engine.page.group',
                }

            ],
        },

        {
            label: 'Agents',
            name: 'agent.page.group',
            icon: 'fas fa-user',
            role: [Role.SUPER_ADMIN],
            submenu: [
                {
                    label: 'Agent',
                    name: 'agent.page.group',
                },
            ],
        },
        {
            label: 'Finance',
            name: '',
            heading: true,
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.STATION_MANAGER, Role.STATION_OFFICER, Role.FINANCIER],
        },
        {
            label: 'Codes',
            name: 'code.page.group',
            icon: 'fas fa-file-code',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.STATION_MANAGER, Role.STATION_OFFICER],
            submenu: [
                {
                    label: 'Codes',
                    name: 'code.page.group',
                },
            ],
        },
        {
            label: 'Claims',
            name: 'claim.page.group',
            icon: 'fas fa-exchange-alt',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.STATION_MANAGER, Role.STATION_OFFICER],
            submenu: [
                {
                    label: 'Claims',
                    name: 'claim.page.group',
                },
                {
                    label: 'Make Claims',
                    name: 'claim.page.create',
                },
            ],
        },
        {
            label: 'Transactions',
            name: 'transaction.page.group',
            icon: 'fas fa-piggy-bank',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER, Role.STATION_MANAGER, Role.STATION_OFFICER, Role.FINANCIER],
            submenu: [
                {
                    label: 'Transaction',
                    name: 'transaction.page.group',
                },
            ],
        },
        {
            label: 'Wallets',
            name: 'wallet.page.group',
            icon: 'fas fa-wallet',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER],
            submenu: [
                {
                    label: 'Wallets',
                    name: 'wallet.page.group',
                },
            ],
        },
        {
            label: 'Swap & Save',
            name: 'swap_save.page.group',
            icon: 'fas fa-layer-group',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER],
        },
        //{
        //	label: 'Disbursements',
        //	name: 'disbursement.page.group',
        //	icon: 'fas fa-coins',
        //},
        {
            label: 'Metadata',
            name: 'meta.page.group',
            icon: 'fas fa-cog',
            role: [Role.SUPER_ADMIN, Role.COUNTRY_MANAGER],
            submenu: [
                {
                    label: 'Metadata',
                    name: 'meta.page.group',
                },
                {
                    label: 'Metadata List',
                    name: 'meta.page.list',
                },
                {
                    label: 'Create Metadata',
                    name: 'meta.page.create',
                },
            ],
        },

        /*{
            label: 'Location Management',
            name: '',
            heading: true,
        },
        {
            label: 'Zone',
            name: 'zone.page.single',
            icon: 'far fa-map',
            submenu: [
                {
                    label: 'Zones',
                    name: 'zone.page.group',
                },
                {
                    label: 'Create Zone',
                    name: 'zone.page.create',
                },
            ],
        },
        {
            label: 'State',
            name: 'state.page.single',
            icon: 'bi bi-geo-alt-fill',
            submenu: [
                {
                    label: 'States',
                    name: 'state.page.group',
                },
                {
                    label: 'Create State',
                    name: 'state.page.create',
                },
            ],
        },
        {
            label: 'Region',
            name: 'region.page.single',
            icon: 'bi bi-geo-alt-fill',
            submenu: [
                {
                    label: 'Regions',
                    name: 'region.page.group',
                },
                {
                    label: 'Create Region',
                    name: 'region.page.create',
                },
            ],
        },
        {
            label: 'Country',
            name: 'country.page.single',
            icon: 'bi bi-globe',
            submenu: [
                {
                    label: 'Countries',
                    name: 'country.page.group',
                },
                {
                    label: 'Create Country',
                    name: 'country.page.create',
                },
            ],
        }*/

        {
            label: 'Profile',
            name: '',
            heading: true,
        },
        {
            label: 'Profile',
            name: 'profile.page.single',
            icon: 'far fa-user',
            submenu: [
                {
                    label: 'Profile',
                    name: 'profile.page.single',
                },
                {
                    label: 'Reset Password',
                    name: 'profile.page.password.reset',
                },
            ],
        },
        {
            label: 'Logout',
            name: 'auth.logout',
            icon: 'fas fa-sign-out-alt',
            external: true,
        },
    ]

    created() {
        if (hasRole(this.$user, Role.SUPER_ADMIN)) {
            this.menu.push(
                // {
                //     label: 'Development Tools',
                //     name: '',
                //     heading: true,
                // },
                // {
                //     label: 'Pulse',
                //     name: 'pulse',
                //     icon: 'fa-solid fa-screwdriver-wrench',
                //     external: true,
                // },
                // {
                //     label: 'Horizon',
                //     name: 'horizon.index',
                //     icon: 'fa-solid fa-screwdriver-wrench',
                //     external: true,
                // },
            )

            if (['staging', 'development', 'local'].includes(import.meta.env.VITE_APP_ENV)) {
                this.menu.push(
                    {
                        label: 'Telescope',
                        name: 'telescope',
                        icon: 'fa-solid fa-screwdriver-wrench',
                        external: true,
                    },
                    {
                        label: 'Mailbook',
                        name: 'mailbook.dashboard',
                        icon: 'fa-solid fa-screwdriver-wrench',
                        external: true,
                    },
                    // {
                    //     label: 'Docs',
                    //     name: 'scribe',
                    //     icon: 'fa-solid fa-screwdriver-wrench',
                    //     external: true,
                    // },
                    // {
                    //     label: 'Tinker',
                    //     name: 'tinker',
                    //     icon: 'fa-solid fa-screwdriver-wrench',
                    //     external: true,
                    // }

                )
            }
        }
    }
}

export default toNative(SidebarLeft)
</script>

<style lang="scss">
.img-banner,
.img-icon {
    width: auto;
    height: 20px;
}
</style>
